// severities
export const HIGHEST_SEVERITY = 'critical'
export const SECOND_HIGHEST_SEVERITY = 'warning'

export const DEFAULT_PRECISION = 2

export const NEW_ALARM_THRESHOLD = 15000 // milliseconds

// local storage paths
export const MUTED_WIDGET_LOCAL_STORAGE_BASEPATH = 'plugin-channel-alarms/muted/'
export const CONFIG_UNIT_SET_LOCAL_STORAGE_PATH = 'plugin-channel-alarms/alarm-configuration-unit-set'

export const WIDTH = 610

export const MIN_CHARS = 20

// sideview
// - modes
export const CONFIGURE = 'configure'
export const VIEW = 'view'
// - sides
export const LEFT = 'left'
export const RIGHT = 'right'

// rules editor
export const editorColumns = [
    { flex: 0, height: '100%', marginRight: 19 },
    { flex: 1, justifyContent: 'flex-start', overflow: 'hidden' },
    { flex: 0.3, maxWidth: 80 },
    { flex: 0.3, maxWidth: 80 },
    { flex: 0.3, maxWidth: 80 },
    { flex: 0.4, minWidth: 98, maxWidth: 106.66 },
    { flex: 0.3, maxWidth: 80 },
    { flex: 0 }
]

// action types
export const CHANGE_RULES = 'CHANGE_RULES'
export const CHANGE_SAVE_STATE = 'CHANGE_SAVE_STATE'
export const CLEAR_ALARMS = 'CLEAR_ALARMS'
export const CLOSE_SIDEVIEW = 'CLOSE_SIDEVIEW'
export const LOAD_NEW_RULE = 'LOAD_NEW_RULE'
export const LOAD_RIG_STATE_OUTPUTS = 'LOAD_RIG_STATE_OUTPUTS'
export const LOAD_RULES = 'LOAD_RULES'
export const NEW_RULE = 'NEW_RULE'
export const OPEN_SIDEVIEW = 'OPEN_SIDEVIEW'
export const QUERY_STOPPED = 'QUERY_STOPPED'
export const REMOVE_RULES = 'REMOVE_RULES'
export const RESTORE_RULE = 'RESTORE_RULE'
export const SET_GLOBAL_ALERT = 'SET_GLOBAL_ALERT'
export const SET_LOADING = 'SET_LOADING'
export const TOGGLE_SELECTED = 'TOGGLE_SELECTED'
export const UPDATE_ALERTS = 'UPDATE_ALERTS'
export const UPDATE_ASSET_ID = 'UPDATE_ASSET_ID'
export const UPDATE_BUTTON_SAVE_STATUS = 'UPDATE_BUTTON_SAVE_STATUS'
export const UPDATE_CURVES = 'UPDATE_CURVES'
export const UPDATE_MUTED_WIDGETS = 'UPDATE_MUTED_WIDGETS'
export const UPDATE_RULES_SERVICE = 'UPDATE_RULES_SERVICE'
export const UPDATE_SOUND_STATUS = 'UPDATE_SOUND_STATUS'
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION'
export const UPDATE_WIDGETS_WITH_ALARMS = 'UPDATE_WIDGETS_WITH_ALARMS'

// BroadcastChannel message types
export const UPDATE_MUTED = 'UPDATE_MUTED'
export const UPDATE_RULES_ASSET = 'UPDATE_RULES_ASSET'
export const UPDATE_SOUND_BROADCAST = 'UPDATE_SOUND_BROADCAST'

// rule property names
export const ACTIVE = 'active'
export const CONDITIONS = 'conditions'
export const DESCRIPTION = 'description'
export const GLOBAL = 'global'
export const SEVERITY = 'severity'
export const SOUND = 'sound'
